import { render, staticRenderFns } from "./DetailSettingsImage.vue?vue&type=template&id=59c7a7f2&scoped=true"
import script from "./DetailSettingsImage.vue?vue&type=script&lang=ts"
export * from "./DetailSettingsImage.vue?vue&type=script&lang=ts"
import style0 from "./DetailSettingsImage.vue?vue&type=style&index=0&id=59c7a7f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c7a7f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c7a7f2')) {
      api.createRecord('59c7a7f2', component.options)
    } else {
      api.reload('59c7a7f2', component.options)
    }
    module.hot.accept("./DetailSettingsImage.vue?vue&type=template&id=59c7a7f2&scoped=true", function () {
      api.rerender('59c7a7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/DetailSettingsImage.vue"
export default component.exports